import layout from 'app/store/layout';
import user from 'app/store/user';
import { handleUnknownError } from 'app/store/utils';

const { setLoader, setModal, createToast } = layout.actions;
const { setUser, clearUser, forgotPasswordUserData } = user.actions;

export { setLoader, setModal, handleUnknownError, setUser, clearUser, createToast, forgotPasswordUserData };
